import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import React from 'react'
import { CUSTOMER_IMPORT_MAX_ROWS } from './constants'

const t = buildTranslate('user_lists.import_row_limit')

type Props = {
  className?: string
}

const ImportRowLimitNote: React.FC<Props> = ({ className }) => (
  <Text.BodyText4 color="grey70" tag="p" className={className}>
    {t('note', { limit: CUSTOMER_IMPORT_MAX_ROWS.toLocaleString() })}
  </Text.BodyText4>
)

export default ImportRowLimitNote
